<ng-template cellTemplate let-dataItem="dataItem">
    <div *ngIf="prefix"
         (click)="$event['ignoreClickOutside'] = true"
         [innerHTML]="((dataItem | property: field) == undefined ? placeholder : prefix + '.' + (dataItem | property: field)) | translate"></div>
    <div *ngIf="message"
         (click)="$event['ignoreClickOutside'] = true"
         [innerHTML]="message | translate: dataItem"></div>
    <div *ngIf="messageRetriever"
         (click)="$event['ignoreClickOutside'] = true"
         [innerHTML]="messageRetriever(dataItem) | translate: dataItem"></div>
</ng-template>
